export default {
	Requirement:[{
            'label': ['The information is provided by VTC Occupation Dictionary.  More details are available at [link]'],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': ['此項資料由VTC 職業資料庫提供。您可以在[link]閱覽更多資料。 '],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': ['此项数据由VTC 职业数据库提供。您可以在[link]阅览更多数据。 '],
            'link': '',
            'langCode': 'zh_CN'
        }],
    Experience:[{
            'label': ['The information is provided by VTC Occupation Dictionary.  More details are available at [link]'],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': ['此項資料由VTC 職業資料庫提供。您可以在[link]閱覽更多資料。 '],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': ['此项数据由VTC 职业数据库提供。您可以在[link]阅览更多数据。 '],
            'link': '',
            'langCode': 'zh_CN'
        }],
    EducationLevel:[{
            'label': ['The information is provided by VTC Occupation Dictionary.  More details are available at [link]'],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': ['此項資料由VTC 職業資料庫提供。您可以在[link]閱覽更多資料。 [link]'],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': ['此项数据由VTC 职业数据库提供。您可以在[link]阅览更多数据。 [link]'],
            'link': '',
            'langCode': 'zh_CN'
        }],
    Skills:[{
            'label': [
                'The Top 10 common skills refer to the most common skills reported in LinkedIn member profiles by those LinkedIn members working in that particular occupation in Hong Kong.  Global data were adopted for some occupations with insufficient local data.',
                'The Top 10 growing skills refer to the fastest growing skills over the past 12 months reported in LinkedIn member profiles by those LinkedIn members working in that particular occupation in Hong Kong. Global data were adopted for some occupations with insufficient local data.',
                'The information is retrieved from LinkedIn Talent Insights (LTI), which provides aggregated statistics of LinkedIn member profiles.',
            ],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': [
                '十大常見技能 是指從事該職業的香港LinkedIn會員在會員資料當中最常填報的技能。有小部分職業由於沒有足夠的本地資料而採用了LinkedIn 全球會員資料作為統計。',
                '十大高增長技能 是指從事此職業的香港LinkedIn會員，在過去十二個月在會員資料填報的技能中錄得最快增長的技能。有小部分職業由於沒有足夠的本地資料而採用了LinkedIn 全球會員資料作為統計。',
                '此項資料是從LinkedIn Talent Insights (LTI) 當中取得。LTI是一個提供LinkedIn會員資料分析的平台。',
            ],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': [
                '十大常见技能 是指从事该职业的香港LinkedIn会员在会员资料当中最常填报的技能。有小部分职业由于没有足够的本地资料而采用了LinkedIn 全球会员资料作为统计。',
                '十大高增长技能 是指从事此职业的香港LinkedIn会员，在过去十二个月在会员资料填报的技能中录得最快增长的技能。有小部分职业由于没有足够的本地资料而采用了LinkedIn 全球会员资料作为统计。',
                '此项资料是从LinkedIn Talent Insights (LTI) 当中取得。LTI是一个提供LinkedIn会员数据分析的平台。',
            ],
            'link': '',
            'langCode': 'zh_CN'
        }],
    Manpoweroutlook:[{
            'label': [
                'Projected demand refers to the projected growth of employment opportunities of the selected occupation in the medium term, in which reference was made in a very crude manner to the results of "2023 Manpower Projection" on the projected manpower requirements of the relevant yet broad "occupation group by economic sector" matrix that this occupation belongs.',
            ],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': [
                '就業前景是指所選職業未來中期的預計就業機會增長，其中粗略地參考了「2023 年人力推算」結果中該職業所屬的相關但概括的「按經濟行業劃分的職業組別」人力需求推算。',
               
            ],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': [
                '就业前景是指所选职业未来中期的预计就业机会增长，其中粗略地参考了「2023 年人力推算」结果中该职业所属的相关但概括的「按经济行业划分的职业组别」人力需求推算。',
              
            ],
            'link': '',
            'langCode': 'zh_CN'
        }],
    Automationpotential:[{
            'label': [
                'The automation potential is a compiled based on results of the [link] "A future that works: Automation, employment, and productivity" published by McKinsey Global Institute in 2017 .  ',
                'The automation potential refers to the proportion of the work activities that can be automated by adapting currently demonstrated technology, while other factors (such as labour cost, cost of deploying automation, economic benefits, social acceptance, etc.) are NOT considered.  ',
                'The results of the original study were adjusted to match the occupations in Talent.gov.hk using weightings of both Hong Kong and US employment figures.',
            ],
            "link_text":"research report",
            'link': 'https://www.mckinsey.com/~/media/mckinsey/featured%20insights/Digital%20Disruption/Harnessing%20automation%20for%20a%20future%20that%20works/MGI-A-future-that-works-Full-report.ashx',
            'langCode': 'en_US'
        },{
            'label': [
                '自動化可能性根據麥肯錫全球研究所(McKinsey Global Institute) 在2017年1月發表的"A future that works: Automation, employment, and productivity"當中的[link]編製。',
                '研究當中的自動化可能性是指按現有技術能夠將工作活動自動化的比例，而其他因素（例如勞動成本、自動化成本、經濟誘因、社會接受程度等）並沒有考慮在內。',
                '原始研究的結果及後經過香港及美國就業人口統計數字的加權調整，以配合Talent.gov.hk所涵蓋的職業組別。',
            ],
            "link_text":"研究結果",
            'link': 'https://www.mckinsey.com/~/media/mckinsey/featured%20insights/Digital%20Disruption/Harnessing%20automation%20for%20a%20future%20that%20works/MGI-A-future-that-works-Full-report.ashx',
            'langCode': 'zh_HK'
        },{
            'label': [
                '自动化可能性根据麦肯锡全球研究所(McKinsey Global Institute) 在2017年1月发表的"A future that works: Automation, employment, and productivity"当中的[link]编制。',
                '研究当中的自动化可能性是指按现有技术能够将工作活动自动化的比例，而其他因素（例如劳动成本、自动化成本、经济诱因、社会接受程度等）并没有考虑在内。',
                '原始研究的结果及后经过香港及美国就业人口统计数字的加权调整，以配合Talent.gov.hk所涵盖的职业组别。',
            ],
            "link_text":"研究结果",
            'link': 'https://www.mckinsey.com/~/media/mckinsey/featured%20insights/Digital%20Disruption/Harnessing%20automation%20for%20a%20future%20that%20works/MGI-A-future-that-works-Full-report.ashx',
            'langCode': 'zh_CN'
        }],
    CareerPath:[{
            'label': [
                'The information is provided by VTC Occupation Dictionary.  More details are available at [link].',
            ],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': [
                '此項資料由VTC 職業資料庫提供。您可以在[link]閱覽更多資料。',
            ],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': [
                '此项数据由VTC 职业数据库提供。您可以在[link]阅览更多数据。',
            ],
            'link': '',
            'langCode': 'zh_CN'
        }],
    RelatedJobOpportunities:[{
            'label': [
                'Information on related job opportunities of the private sector is provided by LinkedIn, while those of the Government (including Civil Servants and Non-Civil Service Contract Staff (NCSC)) is provided by Civil Service Bureau.',
            ],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': [
                '私營機構的相關職位空缺資訊由LinkedIn提供，而政府（包括公務員及非公務員合約員工）的職位空缺資訊由公務員事務局提供。',
            ],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': [
                '私营机构的相关职位空缺信息由LinkedIn提供，而政府（包括公务员及非公务员合约员工）的职位空缺信息由公务员事务局提供。',
            ],
            'link': '',
            'langCode': 'zh_CN'
        }],
    RelatedCourses:[{
            'label': [
                'Related courses comprises of two main sources - Information on local courses are originated from the Qualifications Register, while the Mass Open Online Courses (MOOC) are originated from edX Course Catalog API.',
            ],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': [
                '相關課程包括兩個主要來源 - 本地課程的資料來自資歷名冊，而MOOC課程（大眾開放線上課程）的資料則來自edX Course Catalog API。',
            ],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': [
                '相关课程包括两个主要来源 - 本地课程的资料来自资历名册，而MOOC课程（大众开放在线课程）的资料则来自edX Course Catalog API。',
            ],
            'link': '',
            'langCode': 'zh_CN'
        }]
}